import React from "react";
// import "./index.css";
import { Switch } from "@components/ui/switch";

interface labelSwitchProp {
  label: string;
  error?: string | boolean;
  [key: string]: any;
}
const LabelSwitch: React.FC<labelSwitchProp> = ({
  label,
  error = false,
  ...props
}) => {
  const { checked } = props;

  return (
    <>
      <div className=" flex flex-col w-full">
        {label && (
          <label className="fs-14-600 mb-1 text-[14px] my-2  text-black font-medium">
            {label}
          </label>
        )}
        {/* <Input className={`${props.className  }`} style={{borderColor : error ? webColors.error["base"] : ""}} {...props} /> */}
        <Switch
          name={props?.name}
          className={`${props.className} `}
          checked={checked}
          style={{ borderColor: error ? "bg-red-500" : "" }}
          {...props}
        />
        {error && (
          <span className="fs-12-600 mt-1" style={{ color: "red" }}>
            {error}
          </span>
        )}
      </div>
    </>
  );
};

export default LabelSwitch;
